export default {
  path: 'notes-tasks',
  name: 'product/notes-tasks',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "product-show-notes-tasks" */ './NotesTasks')
}
